export const Description_1 = `
The Air Runner Elite Card is thoughtfully created for frequent flyers, business professionals, and loyal travelers who fly 
often and expect recognition for their continued journeys. It focuses on rewarding consistency, trust, and long-term travel 
commitment. Simple idea. Big value.
`;

export const Description_2 = `
Members receive extra savings on every booking, whether flying short routes or long international journeys, helping reduce 
overall travel costs across the year. Exclusive cardholder-only deals further enhance value. Less spend. More travel.
`;

export const Description_3 = `
Membership levels upgrade automatically after every 100 completed flights, ensuring a seamless and effortless progression 
without manual requests. As travelers move upward, rewards become richer. Fly. Upgrade. Enjoy.
`;

export const Description_4 = `
Each tier introduces greater comfort, smoother services, and elevated recognition from booking to landing. Over time, 
frequent travel unlocks higher status, better savings, and exclusive treatment. Travel, perfected.
`;
